import React from 'react';
import { Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUser,
    faIdCard,
    faPhone,
    faEnvelope,
    faVenusMars,
    faCalendarAlt,
    faHandsHelping,
    faMapMarkerAlt,
    faTint,
    faInfoCircle,
    faShieldAlt,
    faBriefcase,
    faHeartbeat
} from '@fortawesome/free-solid-svg-icons';
import DetailItem from './DetailItem';

const PatientDetailsTab = ({ patientDetails }) => {
    return (
        <>
            <div className="d-flex align-items-center mb-4 border-bottom pb-2">
                <div className="bg-soft-primary p-2 rounded me-2">
                    <FontAwesomeIcon icon={faUser} className="text-primary" />
                </div>
                <h5 className="mb-0 fs-9 fw-bold text-primary">Personal Information</h5>
            </div>
            <Row>
                <DetailItem icon={faUser} label="First Name" value={patientDetails.patient_firstname} />
                <DetailItem icon={faUser} label="Father Name" value={patientDetails.patient_fathername} />
                <DetailItem icon={faUser} label="Family Name" value={patientDetails.patient_familyname} />
                <DetailItem icon={faIdCard} label="National ID" value={patientDetails.patient_nationalid} color="info" />
                <DetailItem icon={faVenusMars} label="Gender" value={patientDetails.genders_disply} color="warning" />
                <DetailItem icon={faCalendarAlt} label="Date of Birth" value={patientDetails.patient_dob} color="success" />
                <DetailItem icon={faPhone} label="Mobile Number" value={patientDetails.patient_mobilenumber} color="danger" />
                <DetailItem icon={faEnvelope} label="Email Address" value={patientDetails.patient_emailid} color="secondary" />
                <DetailItem icon={faHandsHelping} label="Religion" value={patientDetails.religion_disply} color="primary" />
                <DetailItem icon={faInfoCircle} label="Marital Status" value={patientDetails.maritalstatus_disply} color="info" />
                <DetailItem icon={faMapMarkerAlt} label="Nationality" value={patientDetails.natname} color="success" />
                <DetailItem icon={faBriefcase} label="Occupation" value={patientDetails.occup_disply} color="warning" />
            </Row>


            <div className="d-flex align-items-center mb-4 border-bottom pb-2">
                <div className="bg-soft-success p-2 rounded me-2">
                    <FontAwesomeIcon icon={faHeartbeat} className="text-success" />
                </div>
                <h5 className="mb-0 fs-9 fw-bold text-success">Clinical & Other Info</h5>
            </div>
            <Row>
                <DetailItem icon={faTint} label="Blood Group" value={patientDetails.patient_bloodgroup} color="danger" />
                <DetailItem icon={faInfoCircle} label="Refered By" value={patientDetails.patient_referedby} color="info" />
                <DetailItem icon={faInfoCircle} label="Branch Name" value={patientDetails.branch_name} color="primary" />
                <DetailItem icon={faMapMarkerAlt} label="Home Country" value={patientDetails.patient_homecountry} color="success" />
                <DetailItem icon={faMapMarkerAlt} label="Address" value={patientDetails.patient_address} color="secondary" />
            </Row>

            <div className="d-flex align-items-center mb-4 border-bottom pb-2">
                <div className="bg-soft-info p-2 rounded me-2">
                    <FontAwesomeIcon icon={faShieldAlt} className="text-info" />
                </div>
                <h5 className="mb-0 fs-9 fw-bold text-info">Current Insurance Status</h5>
            </div>
            {patientDetails.insurance ? (
                <div className="p-3 bg-soft-info rounded border border-info border-opacity-10">
                    <Row>
                        <DetailItem icon={faShieldAlt} label="Policy Name" value={patientDetails.insurance.patpolcy_name} color="info" />
                        <DetailItem icon={faShieldAlt} label="Policy Number" value={patientDetails.insurance.patpolcy_number} color="info" />
                        <DetailItem icon={faShieldAlt} label="Insurance Class" value={patientDetails.insurance.patins_clsnme} color="info" />
                        <DetailItem icon={faShieldAlt} label="Network Group" value={patientDetails.insurance.patins_network} color="info" />
                    </Row>
                </div>
            ) : (
                <div className="text-center py-4  rounded border border-dashed text-500 fs-10">
                    No active insurance policy found for this patient.
                </div>
            )}
        </>
    );
};

export default PatientDetailsTab;
